/* ══ TRANSLATIONS ══════════════════════════════════════════ */
const T = {
  en: {
    appName:"Command", signIn:"Sign in", email:"Email address", password:"Password",
    rememberMe:"Remember me", forgotPassword:"Forgot password?",
    signOut:"Sign out", owner:"Owner", driver:"Driver", maid:"Household",
    allLocations:"All Locations", location:"Location",
    // Nav
    dashboard:"Dashboard", calendar:"Calendar",
    execution:"Execution", finance:"Finance", income:"Income", expenses:"Expenses",
    recurring:"Recurring", investments:"Investments", operations:"Operations",
    household:"Household", facility:"Facility Management", fleet:"Fleet",
    settings:"Settings",
    // Modules
    newExpense:"Log Expense", newIncome:"Log Income",
    addVehicle:"Add Vehicle", addHome:"Add Home", addUser:"Add User",
    // Status
    open:"Open", waiting:"Waiting", done:"Done", pending:"Pending",
    fulfilled:"Fulfilled", approved:"Approved",
    realised:"Realised", unrealised:"Unrealised", active:"Active",
    // Finance
    totalIncome:"Total Income", totalExpenses:"Total Expenses",
    netCashFlow:"Net Cash Flow",
    // Fields
    amount:"Amount (SAR)", source:"Source", status:"Status", dueDate:"Due Date",
    startDate:"Start Date", endDate:"End Date", frequency:"Frequency",
    category:"Category", subcategory:"Subcategory", description:"Description",
    person:"Person", project:"Project", vehicle:"Vehicle", notes:"Notes",
    priority:"Priority", hat:"Hat", type:"Type", date:"Date", loggedBy:"Logged By",
    // Fleet
    make:"Make", model:"Model", year:"Year", plate:"Plate", color:"Color",
    fuel:"Fuel", purchasePrice:"Purchase Price (SAR)", currentValue:"Current Value (SAR)",
    odometer:"Odometer (KM)", nextServiceKM:"Next Service (KM)",
    nextServiceDate:"Next Service Date", insuranceExpiry:"Insurance Expiry",
    istamaraExpiry:"Istimara Expiry", assignedDriver:"Assigned Driver",
    homeLocation:"Home Location", depreciation:"Depreciation",
    vin:"VIN", registrationNumber:"Registration #", vehiclePhoto:"Vehicle Photo",
    uploadPhoto:"Upload Photo", replacePhoto:"Replace Photo", removePhoto:"Remove",
    exportCsv:"Export CSV",
    // Misc
    high:"High", med:"Med", low:"Low", cancel:"Cancel", save:"Save",
    add:"Add", remove:"Remove", rename:"Rename", close:"Close",
    approve:"Approve", viewInvoice:"View Invoice",
    todayMeetings:"Today's Meetings", noMeetings:"No meetings today",
    invoice:"Invoice", receipt:"Receipt", attachFile:"Attach invoice or receipt",
    overdue:"Overdue",
    hats:"Hats", users:"Users",
    locations:"Locations", vehicles:"Vehicles",
    once:"One-time", monthly:"Monthly", quarterly:"Quarterly", yearly:"Yearly",
    logIssue:"Log Issue", request:"Request",
    myTasks:"My Tasks", myExpenses:"My Expenses", logExpense:"Log Expense",
    language:"Language",
    net:"Net Position",
    global:"Global", none:"None",
    translating:"Translating…",
    // Staff Module
    staff:"Staff", staffManagement:"Staff Management", salariesLeave:"Salaries · Leave",
    addStaff:"Add Staff", addStaffMember:"Add Staff Member", fullName:"Full Name", fullNameAr:"Full Name (Arabic)",
    role:"Role", salarySAR:"Salary (SAR/month)", assignedHome:"Assigned Home", phone:"Phone",
    activeStaff:"Active Staff", monthlyPayroll:"Monthly Payroll", pendingLeave:"Pending Leave",
    inactive:"Inactive", leavePending:"Leave pending", noStaffYet:"No staff members added yet.",
    overview:"Overview", payroll:"Payroll", loans:"Loans", leave:"Leave", documents:"Documents",
    profile:"Profile", home:"Home", salary:"Salary", netAfterDeductions:"Net After Deductions",
    recurringSalary:"Recurring Salary", activeLoans:"Active Loans", totalBalance:"total balance",
    deductingFromPayroll:"Deducting from payroll", payrollSummary:"Payroll Summary",
    editSalary:"Edit Salary", grossSalary:"Gross Salary", loanDeductions:"Loan Deductions",
    netPayable:"Net Payable", newGrossSalary:"New Gross Salary (SAR)", saveUpdate:"Save & Update",
    payslipHistory:"Payslip History", generatePayslip:"Generate Payslip",
    noPayslips:"No payslips generated yet. Click Generate Payslip to record a monthly payment.",
    gross:"Gross", deductions:"Deductions", paid:"Paid", markPaid:"Mark Paid",
    pendingRequestsFromStaff:"Pending Requests from Staff", processedRequests:"Processed Requests",
    activeLoansOnPayroll:"Active Loans on Payroll", recordLoanDirectly:"Record Loan Directly",
    newLoanAdvance:"New Loan / Advance", loanDescription:"Description",
    loanAmount:"Amount (SAR)", loanDate:"Date", deductOverMonths:"Deduct over (months)",
    recordLoan:"Record Loan", noLoans:"No loans or advances recorded.",
    clickToSettle:"Active — click to settle", settled:"Settled",
    totalMonthlyDeduction:"Total monthly deduction from payroll",
    netSalaryLabel:"Net salary", requestLeave:"Request Leave", from:"From", to:"To",
    submitLeave:"Submit", noLeaveRequests:"No leave requests.",
    uploadDocument:"Upload Document", docName:"Name", docTag:"Tag",
    expiryDate:"Expiry Date", optional:"optional", chooseFile:"Choose file",
    upload:"Upload", noDocuments:"No documents uploaded.", download:"Download",
    expiresIn:"expires in", expiresToday:"expires today", days:"days",
    linkedExpenses:"Linked Expenses", noExpensesLinked:"No expenses linked.",
    allStaff:"All Staff", since:"Since", toggle:"Toggle",
    rejected:"Rejected", reject:"Reject", approvedBy:"Approved by", rejectedBy:"Rejected by",
    searchStaff:"Search staff…",
    all:"All", editStaff:"Edit Staff", saveChanges:"Save Changes",
    salaryHistory:"Salary History", changedOn:"Changed on",
    // Staff Settings (Authorities)
    leaveApprovers:"Leave Approvers",
    loanApprovers:"Loan & Advance Approvers",
    salaryReviewers:"Salary Change Reviewers", salaryReviewersDesc:"Notified when a staff salary is updated.",
    approver:"Approver", alwaysIncluded:"Always included", howItWorks:"How it works",
    staffRolesLabel:"Staff Roles", staffRolesDesc:"Roles appear in the Add Staff form and as loginable user profiles (Users → Add User). New roles get Leave + My Info by default; grant more in the staff permissions matrix.",
    newRoleName:"New role name…", addRole:"Add Role",
    staffPermissions:"Staff Permissions",
    canViewStaff:"View staff list", canAddStaff:"Add new staff", canEditStaff:"Edit staff details",
    canManagePayroll:"Manage payroll & salary", canApproveLeave:"Approve/reject leave",
    canApproveLoans:"Approve/reject loans", canManageDocs:"Manage documents",
    resetToDefault:"Reset to platform default",
    // Facility Management
    supplier:"Supplier",
    schedule:"Schedule", complete:"Complete",
    scheduled:"Scheduled", openIssues:"Open Issues", scheduledMaint:"Scheduled",
    overdueMaint:"Overdue Maintenance",
    facilityPerms:"Facility Permissions", facilityPermsDesc:"Control who can manage facility issues and suppliers.",
    canViewMaint:"View maintenance issues", canAddMaint:"Add new issues",
    canEditMaint:"Edit issues", canManageMaint:"Delete issues & change status",
    investmentPerms:"Investment Permissions", investmentPermsDesc:"Control who can view and manage portfolio holdings.",
    canViewInvestments:"View investments", canAddInvestment:"Add holdings",
    canEditInvestment:"Edit holdings", canDeleteInvestment:"Delete holdings",
    canViewSuppliers:"View suppliers", canAddSuppliers:"Add new suppliers",
    canEditSuppliers:"Edit supplier details", canManageSuppliers:"Delete suppliers & manage config",
    supplierPerms:"Supplier Permissions", supplierPermsDesc:"Control who can view and manage approved suppliers.",
    supplierModule:"Module", supplierStatus:"Status", supplierRating:"Rating",
    supplierContractExpiry:"Contract Expiry", supplierTaxId:"Tax / CR No.",
    fleetPerms:"Fleet Permissions", fleetPermsDesc:"Control who can view and manage fleet vehicles.",
    canViewFleet:"View fleet", canAddVehicle:"Add vehicles", canEditVehicle:"Edit vehicles", canManageFleet:"Delete vehicles & manage config",
    nextService:"Next Service",
    serviceOverdue:"Service Overdue",
    insuranceExpiring:"Insurance Expiring",
    istamaraExpiring:"Istimara Expiring",
    unassigned:"Unassigned", updateOdometer:"Update Odometer",
    backToFleet:"Back to Fleet",
    totalExpVehicle:"Total Expenses (This Vehicle)", noExpVehicle:"No expenses linked to this vehicle.",
    noVehicles:"No vehicles. Click \"Add Vehicle\" to get started.",
    // Fleet extras
    plateLettersAr:"Letters (Arabic)", plateLettersEn:"Letters (English)", plateNumbers:"Numbers",
    maintenanceRecords:"Maintenance Records", addMaintenance:"Add Record",
    maintenanceType:"Type", maintenanceCost:"Cost (SAR)", maintenanceProvider:"Provider",
    noMaintRecords:"No maintenance records yet.", mileageHistory:"Mileage History",
    noMileageRecords:"No mileage entries yet.", showAnalytics:"Show Analytics",
    avgMileage:"Avg Mileage",
    // Projects Module
    projects:"Projects", newProject:"New Project", projectName:"Project Name",
    projectNameAr:"Project Name (Arabic)", descriptionAr:"Description (Arabic)",
    editProject:"Edit Project", deleteProject:"Delete Project",
    deleteProjectConfirm:"Are you sure you want to delete this project? Linked tasks and expenses will remain but lose their project link.",
    noProjectsYet:"No projects yet", createProjectHint:"Create a project to group tasks, expenses, and people in one place.",
    budget:"Budget (SAR)", budgetVsActual:"Budget vs Actual", overBudget:"Over Budget",
    searchProjects:"Search projects…",
    allStatuses:"All Statuses",
    onHold:"On Hold", completed:"Completed",
    projectPerms:"Project Permissions", projectPermsDesc:"Control who can view and manage projects.",
    canViewProjects:"View projects", canAddProject:"Add projects",
    canEditProject:"Edit projects", canDeleteProject:"Delete projects",
    // Smart Home
    smartHome:"Smart Home",
    smartHomePerms:"Smart Home Permissions", smartHomePermsDesc:"Control who can view and manage smart home devices.",
    canViewSmartHome:"View Smart Home", canControlDevices:"Control devices", canManageConnections:"Manage connections",
    // Calendar
    dayView:"Day", weekView:"Week", monthView:"Month", today:"Today",
    newCalendar:"New Calendar", calendarName:"Calendar name", addCalendar:"Add Calendar",
    newEvent:"New Event", addEvent:"+ Event", addEventBtn:"Add Event",
    title:"Title", time:"Time", startTime:"Start", endTime:"End",
    account:"Account", calendars:"Calendars",
    noCalendarsYet:"No calendars yet. Add one to get started.",
    todayAtGlance:"Today at a Glance", selectCalendar:"— Select calendar —",
    unifiedCalendarSubtitle:"Unified Calendar · All Accounts", meetingsLabel:"meetings",
    delete:"Delete",
    // Execution
    executionSubtitle:"Tasks · SLA · Escalations", tasksSuffix:"Tasks",
    // Household
    allHomes:"All Homes", groceries:"Groceries", addGroceries:"Add Groceries",
    groceryRequest:"Grocery Request", itemSingular:"item", itemPlural:"items",
    noGroceryRequests:"No grocery requests", inTransit:"In Transit",
    total:"Total", runsPerWeek:"runs / week", avgBill:"Avg Bill",
    minLabel:"Min", maxLabel:"Max", avgDays:"Avg Days",
    fastest:"Fastest", medianBill:"Median Bill", byLocation:"By Location",
    bestFulfillment:"Best Fulfillment", lowestAvgBill:"Lowest Avg Bill",
    highestAvgBill:"Highest Avg Bill", fulfillmentSLA:"Fulfillment SLA",
    unassignedLabel:"Unassigned",
    item:"Item", qty:"Qty", unit:"Unit", unitPh:"kg, pcs…",
    addAll:"Add All", addingInProgress:"Adding...",
    addMoreRows:"+ Add More Rows", itemsReady:"items ready",
    docTagPh:"ID, Iqama…",
    // Settings · BrandingTab
    appIdentity:"App Identity", modulesAndNav:"Modules & Nav",
    workspaceName:"Workspace Name", workspaceNamePh:"e.g. Al-Rashid Family Office",
    subtitleTagline:"Subtitle / Tagline", taglinePh:"e.g. Private Office System · Al-Rashid Family Office",
    workspaceCurrency:"Workspace Currency", currencyDesc:"All financial amounts will be displayed in this currency.",
    householdProfile:"Household Profile", country:"Country", selectCountry:"Select country",
    city:"City", selectCity:"Select city",
    propertyType:"Property Type", selectPropertyType:"Select property type",
    residents:"Residents", selectResidents:"Select residents",
    staffCount:"Staff Count", selectStaffCount:"Select staff count",
    dangerZone:"Danger zone", resetDashboard:"Reset dashboard",
    resetWarningShort:"Erase all workspace data while keeping user accounts intact.",
    resetWarningLong:"This will permanently delete all data except user accounts.",
    typeReset:"Type RESET",
    // Settings · CategoriesManager
    expenseCategories:"Expense Categories", incomeCategories:"Income Categories",
    investmentCategories:"Investment Categories", documentTags:"Document Tags",
    manageExpenseCategories:"Manage Expense Categories",
    manageIncomeCategories:"Manage Income Categories",
    investmentTypes:"Investment Types", fileTags:"File Tags",
    topLevel:"Top-level", parentLabel:"Parent", subShort:"sub",
    newCategoryPh:"New category name…", newIncomeCategoryPh:"New income category…",
    newInvestmentCategoryPh:"New investment category…", newTagPh:"New tag…",
    listed:"Listed", liquidity:"Liquidity",
    liquidityHint:"Liquidity defines how easily the asset class can be converted to cash (High = instant/days, Medium = weeks, Low = months+).",
    expenseCategoriesHint:"Click any name to rename inline. Remove deletes it and all subcategories. Changes apply everywhere instantly.",
    deleteSubcategoryConfirm:"Delete this subcategory?",
    deleteCategoryConfirm:"Delete this category and its subcategories?",
    // Finance · Income/Reports/Investments
    incomeAnalytics:"Income Analytics", monthlyTrend:"Monthly Trend",
    byCategory:"By Category", topSources:"Top Sources", noData:"No data",
    realisedPct:"Realised %", assets:"Assets", liabilities:"Liabilities",
    equity:"Equity", totalAssets:"Total Assets", totalLiabilities:"Total Liabilities",
    netEquity:"Net Equity", noAssetsRecorded:"No assets recorded.",
    noLiabilitiesRecorded:"No liabilities recorded.",
    asset:"Asset", liability:"Liability", subType:"Sub-type",
    operating:"Operating", investment:"Investment", financing:"Financing",
    adjustPosition:"Adjust Position", buyMore:"Buy More",
    partialExit:"Partial Exit", fullExit:"Full Exit",
    additionalShares:"Additional Shares", totalShares:"Total Shares",
    totalInvested:"Total Invested", weightedAvgCost:"Weighted Avg Cost",
    confirmPurchase:"Confirm Purchase", sharesToSell:"Shares to Sell",
    selling:"Selling", proceeds:"Proceeds", plOnSold:"P&L on sold",
    returnOnSold:"Return on sold", remaining:"Remaining",
    linkedLiabilities:"Linked Liabilities", dismiss:"Dismiss",
    discardConfirm:"You have items entered. Discard and close?",
    product:"Product", variant:"Variant", generic:"Generic",
    lastItem:"Last item", requestedBy:"Requested By", requestDate:"Request Date",
    totalCost:"Total Cost", fulfilledDate:"Fulfilled", items:"Items",
    fulfilledSuffix:"fulfilled", logGroceryExpense:"Log Grocery Run Expense",
    lastItemExpenseHint:"This is the last item in the grocery run. Log the total cost to complete the run.",
    fulfillExpenseHint:"Fulfilling this request requires logging the actual expense.",
    intelligence:"Intelligence",
    // Shell / BottomNav
    workspaceLabel:"Workspace", navModules:"Modules", more:"More",
    command:"Command", english:"English", arabic:"العربية", logout:"Logout",
    // Tasks
    newTask:"New Task", edit:"Edit", assignedTo:"Assigned To",
    dueLabel:"Due", noTasks:"No tasks",
    // Projects extras
    accessRestricted:"Access restricted.", projectDetails:"Project details",
    // AI Workspace
    aiProviders:"AI Providers", agents:"Agents", systemPrompt:"System Prompt",
    promptLibrary:"Prompt Library", defineAgentBehavior:"Define this agent's behavior…",
    noSystemPrompt:"No system prompt. Click Edit.", startConversation:"Start a conversation",
    needsApiKeyBackend:"Needs API key in backend", connected:"Connected",
    notConfigured:"Not configured", clear:"Clear", using:"Using", send:"Send",
    ready:"Ready", pickPromptHint:"Pick a prompt from the library or type below.",
    aiProvidersDesc:"Configure which AI providers are available in the Workspace. In production, add your API keys to your backend environment variables — no frontend changes needed.",
    backendEnvVar:"Backend env variable", howToConnect:"How to connect",
    howToConnectDesc:"Add the env variable to your Vercel / Supabase environment variables. Your backend API route reads this key and forwards requests to the provider. No frontend changes needed.",
    selectModelFor:"Select model for", sendingWith:"Sending with",
    msgsCount:"msgs", messageAgent:"Message", enterToSend:"(Enter to send, Shift+Enter for new line)",
    labelPh:"Label…", promptTextPh:"Prompt text…",
    doneEditing:"Done",
    // Files
    filesSecurePassthrough:"Secure pass-through.", filesNotStored:"Files are never stored, copied, or processed by Command. No AI module has access to this section. All operations happen directly with your cloud provider.",
    connect:"Connect", connectedAccounts:"Connected Accounts", comingSoon:"Coming soon",
    filesSubtitle:"Pass-through access · No storage · Isolated from AI",
    connectAccount:"Connect Account", connectCloudStorage:"Connect Cloud Storage",
    provider:"Provider", label:"Label", emailField:"Email",
    labelPhWork:"e.g. Work, Personal", emailPh:"account@email.com",
    howItWorksFiles:"Clicking Connect opens OAuth with your provider. Command receives only a temporary access token. No file names, content, or metadata is stored in Command at any point.",
    connectViaOauth:"Connect via OAuth →",
    openFile:"Open File", nativeEditor:"Native Editor",
    nativeEditorDesc:"This file opens in your provider's native web editor (e.g. Office Online). Edits are saved directly to your cloud storage. Command is not involved in editing or saving.",
    openInProvider:"Open in", providerFallback:"Provider",
    openInProviderDemo:"Production: opens in Office Online / provider native editor in new tab.",
    accounts:"Accounts", pinned:"Pinned", providers:"Providers",
    addAccount:"+ Add account",
    rootFolder:"Root", backNav:"← Back",
    folderEmpty:"This folder is empty.",
    modifiedAt:"Modified", pinBtn:"Pin", unpinBtn:"Unpin",
    statusSoon:"SOON", statusConnected:"CONNECTED",
    comingSoonSuffix:"coming soon.",
    // Menu module
    menuGenerateDesc:"Generate full course-structured meal proposals for the week",
    mealTypes:"Meal types", scope:"Scope",
    optionsPerCourse:"Options per course", customRange:"Custom (1–7)",
    courseStructurePerMeal:"Course structure per meal type",
    preferencesLabel:"Preferences", filterPreferencesPh:"Filter preferences…",
    errorLabel:"Error",
    addMealToLibrary:"Add Meal to Library", mealType:"Meal type",
    saveToLibrary:"Save to library",
    courseLabelPh:"Course label (e.g. Main, Appetizer)",
    arabicPh:"Arabic",
    addDietaryRequirements:"Add Dietary Requirements",
    dietaryPickMsg:"Select one or more requirements to add. Tap to toggle.",
    orTypeCustomRequirement:"Or type a custom requirement",
    thisWeek:"This Week", finalizeMenuBtn:"Finalize Menu",
    noVotingRecorded:"No voting recorded",
    noVotingRecordedDesc:"No voting was recorded for this week.",
    votingWindowClosed:"Voting window closed",
    closedOn:"Closed",
    noProposalsYet:"No proposals yet for this week",
    noProposalsYetDesc:"Generate meal proposals and voting will open for this week.",
    generateProposalsToStart:"Generate proposals to start voting.",
    votingClosedFinalize:"Voting closed. Finalize the menu to lock in the results.",
    votingOpenPill:"Voting Open", votingClosedPill:"Voting Closed",
    closesOnLabel:"Closes",
    votesSavedHint:"✓ Your votes are saved. You can change them until the deadline.",
    aiGenerateHint:"Use ✦ AI Generate to create meal proposals, then vote on each course option — closes",
    votingWindowClosedDesc:"Closed. Navigate to next week to vote.",
    weeklyVoteHint:"One vote per meal type applies across the whole week. Pick your preferred option for each course.",
    noProposalFor:"No proposal for", yetLabel:"yet",
    rateEachHint:"Rate each option 1–5. Higher ratings make it more likely to appear earlier in the week.",
    rateLabel:"Rate:",
    regenerateHint:"to get fresh options.",
    weeklyMenuTab:"Weekly Menu", mealLibraryTab:"Meal Library", dietaryTab:"Dietary",
    addMealBtn:"Meal", aiGenerateBtn:"AI Generate", regenerateBtn:"Regenerate",
    menuPlanningTitle:"Menu Planning",
    menuSubtitle:"AI-Assisted · Family Voting",
    swipeForMoreDays:"Swipe for more days",
    aiMealGenerator:"AI Meal Generator",
    upcomingWeek:"Upcoming week", weekOf:"Week of",
    permanent:"Permanent", availableEveryWeek:"Available every week",
    selectedLabel:"Selected",
    generating:"Generating…", generateProposalsBtn:"Generate Proposals",
    optionBtn:"Option", addCourseBtn:"Add Course",
    noMealsYet:"No meals yet",
    addMealOrUseAi:"Add a meal or use AI Generate",
    deleteBtn:"Delete", cancelBtn:"Cancel",
    noDietaryRequirements:"No dietary requirements",
    // Auth / onboarding / platform
    back:"Back", invalidCode:"Invalid code.",
    requestSubmitted:"Request Submitted",
    pendingBody:"Your workspace request is pending review. You will be notified once it is approved.",
    wsCreated:"Workspace Created", requestWs:"Request Workspace",
    mostPopular:"Most Popular", byInvitation:"By Invitation",
    allFields:"Please fill in all required fields.",
    noWs:"Don't have a workspace? ", createOne:"Create one",
    accountSuspendedOwner:"Account suspended. Please contact the workspace owner.",
    saAccess:"Access", saLogin:"Super Admin", saTitle:"Platform Access",
    incorrectPw:"Incorrect password.",
    impersonating:"Impersonating", exitImpersonation:"Exit",
    demoComingSoon:"Demo video coming soon",
    demoNotUploaded:"The demo video has not been uploaded yet.",
    arabicName:"Arabic name",
    // Workspace settings — edit-user modals
    editUser:"Edit", deleteUser:"Delete User", deletePermanently:"Delete Permanently",
    deleteUserBody:"Are you sure you want to permanently delete",
    cannotBeUndone:"This cannot be undone.",
    codeSentTo:"A verification code was sent to",
    enterToConfirm:"Enter it below to confirm the email change.",
    verificationCode:"Verification Code",
    emailAddress:"Email address",
    newPassword:"New Password",
    leaveBlank:"Leave blank to keep existing",
    whatsappPhone:"WhatsApp / Phone", withCountryCode:"with country code",
    preferredLanguage:"Preferred Language",
    verifyAndSave:"Verify & Save", sendingLabel:"Sending…",
    invalidOrExpired:"Invalid or expired code.",
    networkError:"Network error.",
    failedToSendCode:"Failed to send code.",
    userMgmtLabel:"User Management",
    userMgmtDesc:"Create users with passwords here. Toggle activates/deactivates without deleting. \"Edit Login\" lets you change email and password. \"Perms\" expands the permissions panel inline below. Delete is permanent.",
    editLoginBack:"Back",
    cityField:"City",
    homeType:"Home", farmType:"Farm", officeType:"Office",
    investmentPropertyType:"Investment Property", otherType:"Other",
    // Common
    searchPlaceholder:"Search…", searchOrType:"Search or type…", noResults:"No results",
    name:"Name",
    // Module names (used as fallbacks when SuperAdmin hasn't customized)
    projects:"Projects", reports:"Reports", staff:"Staff", transport:"Transport",
    menu:"Menu Planning", suppliers:"Suppliers", aiWorkspace:"AI Workspace",
    files:"Files", smartHome:"Smart Home",
    workspaceSettings:"Workspace Settings", moduleSettings:"Module Settings",
    // Group labels
    groupCommand:"COMMAND", groupProductivity:"PRODUCTIVITY", groupSystem:"SYSTEM",
    // Tabs / cadence
    oneOff:"One-off",
    // AI panel
    askAI:"Ask AI", refresh:"Refresh", tryColon:"Try:",
    askAnythingPlaceholder:"Ask anything about this data…",
    aiUnavailable:"AI unavailable: ", noResponseReceived:"No response received.",
    // Module subtitles (defaults shown under page titles)
    subtitle_Dashboard:"Snapshot of your finances and operations",
    subtitle_Income:"Realised & Unrealised · Categories & Subcategories",
    subtitle_Expenses:"Log, categorize, and automate recurring expenses like salaries and subscriptions",
    subtitle_Investments:"Track properties, portfolios, and private investments securely",
    subtitle_Projects:"Plan, track, and deliver projects with budgets and milestones",
    subtitle_Fleet:"Vehicles, maintenance, insurance and assignments",
    subtitle_Staff:"Roster, payroll, leave and documents",
    subtitle_FacilityMgmt:"Maintenance, utilities, and home operations",
    subtitle_Reports:"Insights, exports, and tax-ready summaries",
    subtitle_Calendar:"Meetings, deadlines, and recurring events",
    subtitle_AIWorkspace:"Multi-model · Isolated · No access to Files",
    subtitle_Operations:"Day-to-day execution across modules",
    subtitle_Menu:"Plan menus, generate with AI, and manage groceries",
    subtitle_Transport:"Trips, drivers, and route history",
  },
  ar: {
    appName:"Command", signIn:"تسجيل الدخول", email:"البريد الإلكتروني", password:"كلمة المرور",
    rememberMe:"تذكرني", forgotPassword:"نسيت كلمة المرور؟",
    signOut:"تسجيل الخروج", owner:"المالك", driver:"السائق", maid:"المنزل",
    allLocations:"كل المواقع", location:"الموقع",
    dashboard:"لوحة التحكم", calendar:"التقويم",
    execution:"التنفيذ", finance:"المالية", income:"الدخل", expenses:"المصروفات",
    recurring:"المتكررة", investments:"الاستثمارات", operations:"العمليات",
    household:"المنزل", facility:"إدارة المرافق", fleet:"الأسطول",
    settings:"الإعدادات",
    newExpense:"تسجيل مصروف", newIncome:"تسجيل دخل",
    addVehicle:"إضافة مركبة", addHome:"إضافة منزل", addUser:"إضافة مستخدم",
    open:"مفتوح", waiting:"انتظار", done:"مكتمل", pending:"معلق",
    fulfilled:"مكتمل", approved:"موافق عليه",
    realised:"محقق", unrealised:"غير محقق", active:"نشط",
    totalIncome:"إجمالي الدخل", totalExpenses:"إجمالي المصروفات",
    netCashFlow:"صافي التدفق",
    amount:"المبلغ (ريال)", source:"المصدر", status:"الحالة", dueDate:"تاريخ الاستحقاق",
    startDate:"تاريخ البدء", endDate:"تاريخ الانتهاء", frequency:"التكرار",
    category:"الفئة", subcategory:"الفئة الفرعية", description:"الوصف",
    person:"الشخص", project:"المشروع", vehicle:"المركبة", notes:"الملاحظات",
    priority:"الأولوية", hat:"القبعة", type:"النوع", date:"التاريخ", loggedBy:"مسجل بواسطة",
    make:"الماركة", model:"الموديل", year:"السنة", plate:"اللوحة", color:"اللون",
    fuel:"الوقود", purchasePrice:"سعر الشراء (ريال)", currentValue:"القيمة الحالية (ريال)",
    odometer:"العداد (كم)", nextServiceKM:"الصيانة القادمة (كم)",
    nextServiceDate:"تاريخ الصيانة القادمة", insuranceExpiry:"انتهاء التأمين",
    istamaraExpiry:"انتهاء الاستمارة", assignedDriver:"السائق المعين",
    homeLocation:"الموقع", depreciation:"الاستهلاك",
    vin:"رقم الهيكل", registrationNumber:"رقم التسجيل", vehiclePhoto:"صورة المركبة",
    uploadPhoto:"رفع صورة", replacePhoto:"استبدال الصورة", removePhoto:"حذف",
    exportCsv:"تصدير CSV",
    high:"عالي", med:"متوسط", low:"منخفض", cancel:"إلغاء", save:"حفظ",
    add:"إضافة", remove:"حذف", rename:"إعادة تسمية", close:"إغلاق",
    approve:"موافقة", viewInvoice:"عرض الفاتورة",
    todayMeetings:"اجتماعات اليوم", noMeetings:"لا اجتماعات اليوم",
    invoice:"فاتورة", receipt:"إيصال", attachFile:"إرفاق فاتورة أو إيصال",
    overdue:"متأخر",
    hats:"القبعات", users:"المستخدمون",
    locations:"المواقع", vehicles:"المركبات",
    once:"مرة واحدة", monthly:"شهري", quarterly:"ربع سنوي", yearly:"سنوي",
    logIssue:"تسجيل مشكلة", request:"طلب",
    myTasks:"مهامي", myExpenses:"مصروفاتي", logExpense:"تسجيل مصروف",
    language:"اللغة",
    net:"الصافي",
    global:"عام", none:"لا يوجد",
    translating:"جارٍ الترجمة…",
    // Staff Module
    staff:"الموظفون", staffManagement:"إدارة الموظفين", salariesLeave:"الرواتب · الإجازات",
    addStaff:"إضافة موظف", addStaffMember:"إضافة موظف جديد", fullName:"الاسم الكامل", fullNameAr:"الاسم الكامل (عربي)",
    role:"الدور", salarySAR:"الراتب (ريال/شهر)", assignedHome:"الموقع", phone:"الهاتف",
    activeStaff:"الموظفون النشطون", monthlyPayroll:"الرواتب الشهرية", pendingLeave:"إجازات معلقة",
    inactive:"غير نشط", leavePending:"إجازة معلقة", noStaffYet:"لم يتم إضافة موظفين بعد.",
    overview:"نظرة عامة", payroll:"الرواتب", loans:"القروض", leave:"الإجازات", documents:"المستندات",
    profile:"الملف الشخصي", home:"الموقع", salary:"الراتب", netAfterDeductions:"الصافي بعد الاستقطاعات",
    recurringSalary:"الراتب المتكرر", activeLoans:"القروض النشطة", totalBalance:"إجمالي الرصيد",
    deductingFromPayroll:"يُستقطع من الراتب", payrollSummary:"ملخص الرواتب",
    editSalary:"تعديل الراتب", grossSalary:"الراتب الإجمالي", loanDeductions:"استقطاعات القروض",
    netPayable:"الصافي المستحق", newGrossSalary:"الراتب الجديد (ريال)", saveUpdate:"حفظ وتحديث",
    payslipHistory:"سجل كشوف الرواتب", generatePayslip:"إنشاء كشف راتب",
    noPayslips:"لم يتم إنشاء كشوف رواتب بعد. اضغط إنشاء كشف راتب لتسجيل دفعة شهرية.",
    gross:"إجمالي", deductions:"استقطاعات", paid:"مدفوع", markPaid:"تحديد كمدفوع",
    pendingRequestsFromStaff:"طلبات معلقة من الموظفين", processedRequests:"طلبات معالجة",
    activeLoansOnPayroll:"القروض النشطة على الراتب", recordLoanDirectly:"تسجيل قرض مباشر",
    newLoanAdvance:"قرض / سلفة جديدة", loanDescription:"الوصف",
    loanAmount:"المبلغ (ريال)", loanDate:"التاريخ", deductOverMonths:"الاستقطاع على (أشهر)",
    recordLoan:"تسجيل القرض", noLoans:"لا قروض أو سلف مسجلة.",
    clickToSettle:"نشط — اضغط للتسوية", settled:"مسوّى",
    totalMonthlyDeduction:"إجمالي الاستقطاع الشهري من الراتب",
    netSalaryLabel:"صافي الراتب", requestLeave:"طلب إجازة", from:"من", to:"إلى",
    submitLeave:"إرسال", noLeaveRequests:"لا طلبات إجازة.",
    uploadDocument:"رفع مستند", docName:"الاسم", docTag:"التصنيف",
    expiryDate:"تاريخ الانتهاء", optional:"اختياري", chooseFile:"اختر ملف",
    upload:"رفع", noDocuments:"لم يتم رفع مستندات.", download:"تحميل",
    expiresIn:"ينتهي خلال", expiresToday:"ينتهي اليوم", days:"أيام",
    linkedExpenses:"المصروفات المرتبطة", noExpensesLinked:"لا مصروفات مرتبطة.",
    allStaff:"جميع الموظفين", since:"منذ", toggle:"تبديل",
    rejected:"مرفوض", reject:"رفض", approvedBy:"موافق بواسطة", rejectedBy:"مرفوض بواسطة",
    searchStaff:"بحث في الموظفين…",
    all:"الكل", editStaff:"تعديل الموظف", saveChanges:"حفظ التغييرات",
    salaryHistory:"سجل الرواتب", changedOn:"تم التغيير في",
    // Staff Settings (Authorities)
    leaveApprovers:"مسؤولو الإجازات",
    loanApprovers:"مسؤولو القروض والسلف",
    salaryReviewers:"مراجعو تغييرات الرواتب", salaryReviewersDesc:"يتم إشعارهم عند تحديث راتب موظف.",
    approver:"مسؤول", alwaysIncluded:"مضمّن دائماً", howItWorks:"كيف يعمل",
    staffRolesLabel:"أدوار الموظفين", staffRolesDesc:"تظهر الأدوار في نموذج إضافة موظف وكملفات مستخدمين قابلة لتسجيل الدخول (المستخدمون ← إضافة مستخدم). تحصل الأدوار الجديدة على الإجازات وصفحة معلوماتي تلقائياً؛ لمنح المزيد، استخدم مصفوفة صلاحيات الموظفين.",
    newRoleName:"اسم الدور الجديد…", addRole:"إضافة دور",
    staffPermissions:"صلاحيات الموظفين",
    canViewStaff:"عرض قائمة الموظفين", canAddStaff:"إضافة موظف جديد", canEditStaff:"تعديل بيانات الموظف",
    canManagePayroll:"إدارة الرواتب", canApproveLeave:"الموافقة/رفض الإجازات",
    canApproveLoans:"الموافقة/رفض القروض", canManageDocs:"إدارة المستندات",
    resetToDefault:"إعادة إلى الافتراضي",
    // Facility Management
    supplier:"المورد",
    schedule:"جدولة", complete:"إكمال",
    scheduled:"مجدول", openIssues:"مشاكل مفتوحة", scheduledMaint:"مجدولة",
    overdueMaint:"صيانة متأخرة",
    facilityPerms:"صلاحيات المرافق", facilityPermsDesc:"تحكم في من يمكنه إدارة مشاكل الصيانة والموردين.",
    canViewMaint:"عرض مشاكل الصيانة", canAddMaint:"إضافة مشاكل جديدة",
    canEditMaint:"تعديل المشاكل", canManageMaint:"حذف المشاكل وتغيير الحالة",
    investmentPerms:"صلاحيات الاستثمار", investmentPermsDesc:"تحكم في من يمكنه عرض وإدارة محفظة الاستثمارات.",
    canViewInvestments:"عرض الاستثمارات", canAddInvestment:"إضافة حيازات",
    canEditInvestment:"تعديل الحيازات", canDeleteInvestment:"حذف الحيازات",
    canViewSuppliers:"عرض الموردين", canAddSuppliers:"إضافة موردين جدد",
    canEditSuppliers:"تعديل بيانات الموردين", canManageSuppliers:"حذف الموردين وإدارة الإعدادات",
    supplierPerms:"صلاحيات الموردين", supplierPermsDesc:"التحكم في من يمكنه عرض وإدارة الموردين المعتمدين.",
    supplierModule:"القسم", supplierStatus:"الحالة", supplierRating:"التقييم",
    supplierContractExpiry:"انتهاء العقد", supplierTaxId:"رقم ضريبي / سجل تجاري",
    fleetPerms:"صلاحيات الأسطول", fleetPermsDesc:"التحكم في من يمكنه عرض وإدارة مركبات الأسطول.",
    canViewFleet:"عرض الأسطول", canAddVehicle:"إضافة مركبات", canEditVehicle:"تعديل المركبات", canManageFleet:"حذف المركبات وإدارة الإعدادات",
    nextService:"الصيانة القادمة",
    serviceOverdue:"صيانة متأخرة",
    insuranceExpiring:"التأمين ينتهي قريباً",
    istamaraExpiring:"الاستمارة تنتهي قريباً",
    unassigned:"غير معين", updateOdometer:"تحديث العداد",
    backToFleet:"العودة إلى الأسطول",
    totalExpVehicle:"إجمالي المصروفات (هذه المركبة)", noExpVehicle:"لا مصروفات مرتبطة بهذه المركبة.",
    noVehicles:"لا مركبات. انقر \"إضافة مركبة\" للبدء.",
    // Fleet extras
    plateLettersAr:"الحروف (عربي)", plateLettersEn:"الحروف (إنجليزي)", plateNumbers:"الأرقام",
    maintenanceRecords:"سجلات الصيانة", addMaintenance:"إضافة سجل",
    maintenanceType:"النوع", maintenanceCost:"التكلفة (ريال)", maintenanceProvider:"مزود الخدمة",
    noMaintRecords:"لا توجد سجلات صيانة بعد.", mileageHistory:"سجل المسافات",
    noMileageRecords:"لا توجد إدخالات مسافات بعد.", showAnalytics:"عرض التحليلات",
    avgMileage:"متوسط المسافات",
    // Projects Module
    projects:"المشاريع", newProject:"مشروع جديد", projectName:"اسم المشروع",
    projectNameAr:"اسم المشروع (عربي)", descriptionAr:"الوصف (عربي)",
    editProject:"تعديل المشروع", deleteProject:"حذف المشروع",
    deleteProjectConfirm:"هل أنت متأكد من حذف هذا المشروع؟ ستبقى المهام والمصروفات المرتبطة لكن ستفقد ربطها بالمشروع.",
    noProjectsYet:"لا مشاريع بعد", createProjectHint:"أنشئ مشروعاً لتجميع المهام والمصروفات والأشخاص في مكان واحد.",
    budget:"الميزانية (ريال)", budgetVsActual:"الميزانية مقابل الفعلي", overBudget:"تجاوز الميزانية",
    searchProjects:"بحث في المشاريع…",
    allStatuses:"كل الحالات",
    onHold:"معلق", completed:"مكتمل",
    projectPerms:"صلاحيات المشاريع", projectPermsDesc:"التحكم بمن يمكنه عرض وإدارة المشاريع.",
    canViewProjects:"عرض المشاريع", canAddProject:"إضافة مشاريع",
    canEditProject:"تعديل المشاريع", canDeleteProject:"حذف المشاريع",
    // Smart Home
    smartHome:"المنزل الذكي",
    smartHomePerms:"صلاحيات المنزل الذكي", smartHomePermsDesc:"التحكم بمن يمكنه عرض وإدارة أجهزة المنزل الذكي.",
    canViewSmartHome:"عرض المنزل الذكي", canControlDevices:"التحكم بالأجهزة", canManageConnections:"إدارة الاتصالات",
    // Calendar
    dayView:"يوم", weekView:"أسبوع", monthView:"شهر", today:"اليوم",
    newCalendar:"تقويم جديد", calendarName:"اسم التقويم", addCalendar:"إضافة تقويم",
    newEvent:"حدث جديد", addEvent:"+ حدث", addEventBtn:"إضافة حدث",
    title:"العنوان", time:"الوقت", startTime:"البداية", endTime:"النهاية",
    account:"الحساب", calendars:"التقويمات",
    noCalendarsYet:"لا توجد تقويمات بعد. أضف واحداً للبدء.",
    todayAtGlance:"اليوم في لمحة", selectCalendar:"— اختر تقويماً —",
    unifiedCalendarSubtitle:"تقويم موحد · جميع الحسابات", meetingsLabel:"اجتماعات",
    delete:"حذف",
    // Execution
    executionSubtitle:"المهام · الالتزام · التصعيدات", tasksSuffix:"المهام",
    // Household
    allHomes:"جميع المنازل", groceries:"البقالة", addGroceries:"إضافة بقالة",
    groceryRequest:"طلب بقالة", itemSingular:"عنصر", itemPlural:"عناصر",
    noGroceryRequests:"لا توجد طلبات بقالة", inTransit:"في الطريق",
    total:"الإجمالي", runsPerWeek:"رحلات / أسبوع", avgBill:"متوسط الفاتورة",
    minLabel:"أدنى", maxLabel:"أعلى", avgDays:"متوسط الأيام",
    fastest:"الأسرع", medianBill:"وسيط الفواتير", byLocation:"حسب الموقع",
    bestFulfillment:"أعلى معدل إنجاز", lowestAvgBill:"أقل متوسط فاتورة",
    highestAvgBill:"أعلى متوسط فاتورة", fulfillmentSLA:"الالتزام بالتسليم",
    unassignedLabel:"غير معيّن",
    item:"العنصر", qty:"الكمية", unit:"الوحدة", unitPh:"كجم، قطعة…",
    addAll:"إضافة الكل", addingInProgress:"جارٍ الإضافة...",
    addMoreRows:"+ إضافة صفوف", itemsReady:"عنصر جاهز",
    docTagPh:"هوية، إقامة…",
    // Settings · BrandingTab
    appIdentity:"هوية التطبيق", modulesAndNav:"الوحدات والتنقل",
    workspaceName:"اسم مساحة العمل", workspaceNamePh:"مثال: مكتب عائلة الراشد",
    subtitleTagline:"العنوان الفرعي / الشعار", taglinePh:"مثال: نظام المكتب الخاص · مكتب عائلة الراشد",
    workspaceCurrency:"عملة مساحة العمل", currencyDesc:"ستُعرض جميع المبالغ المالية بهذه العملة.",
    householdProfile:"ملف المنزل", country:"الدولة", selectCountry:"اختر الدولة",
    city:"المدينة", selectCity:"اختر المدينة",
    propertyType:"نوع العقار", selectPropertyType:"اختر نوع العقار",
    residents:"السكان", selectResidents:"اختر عدد السكان",
    staffCount:"عدد الموظفين", selectStaffCount:"اختر عدد الموظفين",
    dangerZone:"منطقة الخطر", resetDashboard:"إعادة تعيين لوحة التحكم",
    resetWarningShort:"حذف جميع بيانات مساحة العمل مع الاحتفاظ بحسابات المستخدمين.",
    resetWarningLong:"سيؤدي هذا إلى حذف جميع البيانات نهائياً باستثناء حسابات المستخدمين.",
    typeReset:"اكتب RESET",
    // Settings · CategoriesManager
    expenseCategories:"فئات المصروفات", incomeCategories:"فئات الدخل",
    investmentCategories:"فئات الاستثمار", documentTags:"تصنيفات المستندات",
    manageExpenseCategories:"إدارة فئات المصروفات",
    manageIncomeCategories:"إدارة فئات الدخل",
    investmentTypes:"أنواع الاستثمار", fileTags:"تصنيفات الملفات",
    topLevel:"المستوى الأعلى", parentLabel:"الأصل", subShort:"فرعية",
    newCategoryPh:"اسم فئة جديدة…", newIncomeCategoryPh:"فئة دخل جديدة…",
    newInvestmentCategoryPh:"فئة استثمار جديدة…", newTagPh:"تصنيف جديد…",
    listed:"مدرجة", liquidity:"السيولة",
    liquidityHint:"السيولة تحدد مدى سهولة تحويل فئة الأصول إلى نقد (عالية = فوري/أيام، متوسطة = أسابيع، منخفضة = أشهر وأكثر).",
    expenseCategoriesHint:"انقر على أي اسم لإعادة تسميته. يؤدي الحذف إلى إزالة الفئة وجميع فئاتها الفرعية. التغييرات تسري فوراً في كل مكان.",
    deleteSubcategoryConfirm:"حذف هذه الفئة الفرعية؟",
    deleteCategoryConfirm:"حذف هذه الفئة وفئاتها الفرعية؟",
    // Finance · Income/Reports/Investments
    incomeAnalytics:"تحليلات الدخل", monthlyTrend:"الاتجاه الشهري",
    byCategory:"حسب الفئة", topSources:"أهم المصادر", noData:"لا توجد بيانات",
    realisedPct:"نسبة المحقق", assets:"الأصول", liabilities:"الخصوم",
    equity:"حقوق الملكية", totalAssets:"إجمالي الأصول", totalLiabilities:"إجمالي الخصوم",
    netEquity:"صافي حقوق الملكية", noAssetsRecorded:"لا توجد أصول مسجلة.",
    noLiabilitiesRecorded:"لا توجد خصوم مسجلة.",
    asset:"أصل", liability:"خصم", subType:"النوع الفرعي",
    operating:"تشغيلي", investment:"استثماري", financing:"تمويلي",
    adjustPosition:"تعديل المركز", buyMore:"شراء إضافي",
    partialExit:"خروج جزئي", fullExit:"خروج كامل",
    additionalShares:"أسهم إضافية", totalShares:"إجمالي الأسهم",
    totalInvested:"إجمالي المستثمر", weightedAvgCost:"متوسط التكلفة المرجح",
    confirmPurchase:"تأكيد الشراء", sharesToSell:"أسهم للبيع",
    selling:"البيع", proceeds:"العائدات", plOnSold:"الربح/الخسارة المحققة",
    returnOnSold:"العائد على المبيع", remaining:"المتبقي",
    linkedLiabilities:"الخصوم المرتبطة", dismiss:"تجاهل",
    discardConfirm:"هناك عناصر مُدخلة. هل تريد تجاهلها والإغلاق؟",
    product:"منتج", variant:"نوع", generic:"عام",
    lastItem:"آخر عنصر", requestedBy:"طلب بواسطة", requestDate:"تاريخ الطلب",
    totalCost:"التكلفة الإجمالية", fulfilledDate:"تاريخ الإكمال", items:"العناصر",
    fulfilledSuffix:"مكتمل", logGroceryExpense:"تسجيل مصروف البقالة",
    lastItemExpenseHint:"هذا آخر عنصر في طلب البقالة. سجّل التكلفة الإجمالية لإكمال الطلب.",
    fulfillExpenseHint:"يتطلب إكمال هذا الطلب تسجيل المصروف الفعلي.",
    intelligence:"الذكاء",
    // Shell / BottomNav
    workspaceLabel:"مساحة العمل", navModules:"الوحدات", more:"المزيد",
    command:"القيادة", english:"English", arabic:"العربية", logout:"تسجيل الخروج",
    // Tasks
    newTask:"مهمة جديدة", edit:"تعديل", assignedTo:"المسؤول",
    dueLabel:"الاستحقاق", noTasks:"لا توجد مهام",
    // Projects extras
    accessRestricted:"الوصول مقيّد.", projectDetails:"تفاصيل المشروع",
    // AI Workspace
    aiProviders:"مزودو الذكاء الاصطناعي", agents:"الوكلاء", systemPrompt:"توجيه النظام",
    promptLibrary:"مكتبة التوجيهات", defineAgentBehavior:"حدّد سلوك هذا الوكيل…",
    noSystemPrompt:"لا يوجد توجيه نظام. اضغط تعديل.", startConversation:"ابدأ محادثة",
    needsApiKeyBackend:"يحتاج مفتاح API في الخادم", connected:"متصل",
    notConfigured:"غير مُعدّ", clear:"مسح", using:"باستخدام", send:"إرسال",
    ready:"جاهز", pickPromptHint:"اختر توجيهاً من المكتبة أو اكتب أدناه.",
    aiProvidersDesc:"اختر مزودي الذكاء الاصطناعي المتاحين في مساحة العمل. في الإنتاج، أضف مفاتيح API إلى متغيرات بيئة الخادم — لا تغييرات في الواجهة مطلوبة.",
    backendEnvVar:"متغيّر بيئة الخادم", howToConnect:"كيفية الاتصال",
    howToConnectDesc:"أضف المتغيّر إلى متغيرات البيئة في Vercel / Supabase. يقرأ الخادم المفتاح ويمرّر الطلبات إلى المزود. لا تغييرات في الواجهة مطلوبة.",
    selectModelFor:"اختر نموذجاً لـ", sendingWith:"إرسال باستخدام",
    msgsCount:"رسائل", messageAgent:"رسالة إلى", enterToSend:"(Enter للإرسال، Shift+Enter لسطر جديد)",
    labelPh:"التسمية…", promptTextPh:"نص التوجيه…",
    doneEditing:"تم",
    // Files
    filesSecurePassthrough:"تمرير آمن.", filesNotStored:"لا يتم تخزين الملفات أو نسخها أو معالجتها بواسطة Command. لا تملك أي وحدة ذكاء اصطناعي وصولاً لهذا القسم. جميع العمليات تتم مباشرة مع مزود السحابة لديك.",
    connect:"اتصال", connectedAccounts:"الحسابات المتصلة", comingSoon:"قريباً",
    filesSubtitle:"وصول تمريري · بدون تخزين · معزول عن الذكاء الاصطناعي",
    connectAccount:"ربط حساب", connectCloudStorage:"ربط تخزين سحابي",
    provider:"المزود", label:"التسمية", emailField:"البريد الإلكتروني",
    labelPhWork:"مثال: عمل، شخصي", emailPh:"account@email.com",
    howItWorksFiles:"بالضغط على اتصال تُفتح عملية OAuth مع مزودك. يستقبل Command رمز وصول مؤقتاً فقط. لا تُخزَّن أسماء ملفات أو محتوى أو بيانات وصفية في Command في أي وقت.",
    connectViaOauth:"الاتصال عبر OAuth ←",
    openFile:"فتح ملف", nativeEditor:"المحرر الأصلي",
    nativeEditorDesc:"يُفتح هذا الملف في المحرر الأصلي لمزودك (مثل Office Online). تُحفظ التعديلات مباشرة في تخزينك السحابي. Command غير متدخل في التحرير أو الحفظ.",
    openInProvider:"فتح في", providerFallback:"المزود",
    openInProviderDemo:"في الإنتاج: يُفتح في Office Online / المحرر الأصلي للمزود في تبويب جديد.",
    accounts:"الحسابات", pinned:"المثبّتة", providers:"المزودون",
    addAccount:"+ إضافة حساب",
    rootFolder:"الجذر", backNav:"← رجوع",
    folderEmpty:"هذا المجلد فارغ.",
    modifiedAt:"عُدِّل", pinBtn:"تثبيت", unpinBtn:"إلغاء التثبيت",
    statusSoon:"قريباً", statusConnected:"متصل",
    comingSoonSuffix:"قريباً.",
    // Menu module
    menuGenerateDesc:"توليد مقترحات وجبات منظمة الأطباق لكامل الأسبوع",
    mealTypes:"أنواع الوجبات", scope:"النطاق",
    optionsPerCourse:"خيارات لكل طبق", customRange:"مخصص (1–7)",
    courseStructurePerMeal:"هيكل الأطباق لكل نوع وجبة",
    preferencesLabel:"التفضيلات", filterPreferencesPh:"تصفية التفضيلات…",
    errorLabel:"خطأ",
    addMealToLibrary:"إضافة وجبة للمكتبة", mealType:"نوع الوجبة",
    saveToLibrary:"حفظ في المكتبة",
    courseLabelPh:"تسمية الطبق (مثال: رئيسي، مقبلات)",
    arabicPh:"عربي",
    addDietaryRequirements:"إضافة متطلبات غذائية",
    dietaryPickMsg:"اختر متطلباً أو أكثر لإضافته. اضغط للتبديل.",
    orTypeCustomRequirement:"أو اكتب متطلباً مخصصاً",
    thisWeek:"هذا الأسبوع", finalizeMenuBtn:"اعتماد القائمة",
    noVotingRecorded:"لا يوجد تصويت مسجّل",
    noVotingRecordedDesc:"لم يُسجَّل أي تصويت لهذا الأسبوع.",
    votingWindowClosed:"نافذة التصويت أُغلقت",
    closedOn:"أُغلقت في",
    noProposalsYet:"لا مقترحات بعد لهذا الأسبوع",
    noProposalsYetDesc:"ولّد مقترحات وجبات ليُفتح التصويت لهذا الأسبوع.",
    generateProposalsToStart:"ولّد مقترحات لبدء التصويت.",
    votingClosedFinalize:"التصويت أُغلق. اعتمد القائمة لتثبيت النتائج.",
    votingOpenPill:"التصويت مفتوح", votingClosedPill:"التصويت مُغلق",
    closesOnLabel:"يُغلق",
    votesSavedHint:"✓ تم حفظ أصواتك. يمكنك تعديلها حتى الموعد النهائي.",
    aiGenerateHint:"استخدم ✦ التوليد بالذكاء الاصطناعي لإنشاء مقترحات الوجبات، ثم صوّت على كل خيار ضمن الطبق — يُغلق",
    votingWindowClosedDesc:"أُغلقت النافذة. انتقل إلى الأسبوع التالي للتصويت.",
    weeklyVoteHint:"صوت واحد لكل نوع وجبة يُطبَّق على الأسبوع بكامله. اختر خيارك المفضّل لكل طبق.",
    noProposalFor:"لا يوجد مقترح لـ", yetLabel:"بعد",
    rateEachHint:"قيّم كل خيار من 1 إلى 5. التقييمات الأعلى تزيد احتمال ظهوره في بداية الأسبوع.",
    rateLabel:"قيّم:",
    regenerateHint:"للحصول على خيارات جديدة.",
    weeklyMenuTab:"قائمة الأسبوع", mealLibraryTab:"مكتبة الوجبات", dietaryTab:"الحمية",
    addMealBtn:"وجبة", aiGenerateBtn:"توليد بالذكاء الاصطناعي", regenerateBtn:"إعادة التوليد",
    menuPlanningTitle:"تخطيط القائمة",
    menuSubtitle:"بمساعدة الذكاء الاصطناعي · تصويت العائلة",
    swipeForMoreDays:"اسحب لمزيد من الأيام",
    aiMealGenerator:"مولّد الوجبات بالذكاء الاصطناعي",
    upcomingWeek:"الأسبوع القادم", weekOf:"أسبوع",
    permanent:"دائم", availableEveryWeek:"متاح كل أسبوع",
    selectedLabel:"المختار",
    generating:"جارٍ التوليد…", generateProposalsBtn:"توليد المقترحات",
    optionBtn:"خيار", addCourseBtn:"إضافة طبق",
    noMealsYet:"لا توجد وجبات",
    addMealOrUseAi:"أضف وجبة أو استخدم المولّد الذكي",
    deleteBtn:"حذف", cancelBtn:"إلغاء",
    noDietaryRequirements:"لا توجد متطلبات غذائية",
    // Auth / onboarding / platform
    back:"رجوع", invalidCode:"رمز غير صالح.",
    requestSubmitted:"تم تقديم الطلب",
    pendingBody:"طلب مساحة العمل قيد المراجعة. ستُعلَم حال الموافقة عليه.",
    wsCreated:"تم إنشاء مساحة العمل", requestWs:"طلب مساحة عمل",
    mostPopular:"الأكثر شيوعاً", byInvitation:"بدعوة فقط",
    allFields:"يرجى تعبئة جميع الحقول المطلوبة.",
    noWs:"ليس لديك مساحة عمل؟ ", createOne:"أنشئ واحدة",
    accountSuspendedOwner:"الحساب موقوف. يرجى التواصل مع مالك مساحة العمل.",
    saAccess:"الدخول", saLogin:"المسؤول الأعلى", saTitle:"الوصول للمنصة",
    incorrectPw:"كلمة المرور غير صحيحة.",
    impersonating:"انتحال شخصية", exitImpersonation:"خروج",
    demoComingSoon:"الفيديو التجريبي قادم قريباً",
    demoNotUploaded:"لم يُرفَع الفيديو التجريبي بعد.",
    arabicName:"اسم عربي",
    // Workspace settings — edit-user modals
    editUser:"تعديل", deleteUser:"حذف المستخدم", deletePermanently:"حذف نهائي",
    deleteUserBody:"هل أنت متأكد من الحذف النهائي للمستخدم",
    cannotBeUndone:"لا يمكن التراجع عن هذا الإجراء.",
    codeSentTo:"تم إرسال رمز التحقق إلى",
    enterToConfirm:"أدخل الرمز أدناه لتأكيد تغيير البريد الإلكتروني.",
    verificationCode:"رمز التحقق",
    emailAddress:"البريد الإلكتروني",
    newPassword:"كلمة المرور الجديدة",
    leaveBlank:"اتركه فارغاً للإبقاء على الحالي",
    whatsappPhone:"واتساب / الهاتف", withCountryCode:"مع رمز الدولة",
    preferredLanguage:"اللغة المفضلة",
    verifyAndSave:"تحقق واحفظ", sendingLabel:"جارٍ الإرسال…",
    invalidOrExpired:"الرمز غير صالح أو منتهي الصلاحية.",
    networkError:"خطأ في الشبكة.",
    failedToSendCode:"فشل إرسال الرمز.",
    userMgmtLabel:"إدارة المستخدمين",
    userMgmtDesc:"أنشئ المستخدمين مع كلمات مرورهم هنا. زر التبديل يُفعّل/يُعطّل الحساب دون حذفه. \"تعديل الدخول\" يسمح بتغيير البريد وكلمة المرور. \"الصلاحيات\" توسّع لوحة الصلاحيات أدناه. الحذف نهائي.",
    editLoginBack:"رجوع",
    cityField:"المدينة",
    homeType:"منزل", farmType:"مزرعة", officeType:"مكتب",
    investmentPropertyType:"عقار استثماري", otherType:"أخرى",
    // Common
    searchPlaceholder:"بحث…", searchOrType:"ابحث أو اكتب…", noResults:"لا نتائج",
    name:"الاسم",
    // Module names
    projects:"المشاريع", reports:"التقارير", staff:"الموظفون", transport:"النقل",
    menu:"تخطيط القائمة", suppliers:"الموردون", aiWorkspace:"مساحة الذكاء الاصطناعي",
    files:"الملفات", smartHome:"المنزل الذكي",
    workspaceSettings:"إعدادات مساحة العمل", moduleSettings:"إعدادات الوحدات",
    // Group labels
    groupCommand:"القيادة", groupProductivity:"الإنتاجية", groupSystem:"النظام",
    // Tabs / cadence
    oneOff:"دفعة واحدة",
    // AI panel
    askAI:"اسأل", refresh:"تحديث", tryColon:"جرّب:",
    askAnythingPlaceholder:"اسأل أي شيء عن هذه البيانات…",
    aiUnavailable:"الذكاء الاصطناعي غير متوفر: ", noResponseReceived:"لم يتم استلام رد.",
    // Module subtitles (defaults shown under page titles)
    subtitle_Dashboard:"لمحة عن أموالك وعملياتك",
    subtitle_Income:"المحقق وغير المحقق · الفئات والفئات الفرعية",
    subtitle_Expenses:"سجّل وصنّف وأتمت المصروفات المتكررة كالرواتب والاشتراكات",
    subtitle_Investments:"تتبّع العقارات والمحافظ والاستثمارات الخاصة بأمان",
    subtitle_Projects:"خطّط وتابع وسلّم المشاريع بالميزانيات والمعالم",
    subtitle_Fleet:"المركبات والصيانة والتأمين والتعيينات",
    subtitle_Staff:"الموظفون والرواتب والإجازات والوثائق",
    subtitle_FacilityMgmt:"الصيانة والمرافق وعمليات المنزل",
    subtitle_Reports:"تحليلات وتصدير وملخصات جاهزة للضريبة",
    subtitle_Calendar:"الاجتماعات والمواعيد النهائية والأحداث المتكررة",
    subtitle_AIWorkspace:"متعدد النماذج · معزول · لا وصول إلى الملفات",
    subtitle_Operations:"التنفيذ اليومي عبر الوحدات",
    subtitle_Menu:"خطط للقوائم وأنشئها بالذكاء الاصطناعي وأدر البقالة",
    subtitle_Transport:"الرحلات والسائقون وسجل الطرق",
  }
};

export default T;
